import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';

import * as PaymentsConstants from '../../constants';
import * as D from '../../deps';
import * as PaymentsUtils from '../../utils';

import './SubscriptionTermsLink.scss';

const SubscriptionTermsLink = ({
  discountType = PaymentsConstants.discountTypes.NONE,
  intl,
  isBackgroundLight,
  isBlueUrl,
}) => {
  const termsLinkText = PaymentsUtils.getTermsLinkText(discountType);
  const termsUrl = PaymentsUtils.getTermsUrl(discountType);
  const classNames = D.createBEM('SubscriptionTermsLink', {
    lightBackground: isBackgroundLight,
    blue: isBlueUrl,
  });
  return (
    <a
      className={classNames}
      title={intl.formatMessage(PaymentsConstants.Messages.newWindowLink)}
      href={termsUrl}
      target='_blank'
      rel='noopener noreferrer'
      data-qa={D.Constants.QATags.PSSTL}
    >
      <FormattedMessage {...termsLinkText} />
    </a>
  );
};

SubscriptionTermsLink.propTypes = {
  discountType: PropTypes.oneOf(Object.keys(PaymentsConstants.discountTypes)),
  intl: PropTypes.object.isRequired,
  isBackgroundLight: PropTypes.bool,
  isBlueUrl: PropTypes.bool,
};

export default injectIntl(SubscriptionTermsLink);
